<template>
  <div class="page page-about-app content">
    <h1 class="page__title">{{ t('aboutApp.menuTitle') }}</h1>
    <About />
  </div>
</template>

<script>
  import About from '@/components/settings/About.vue'
  import { useStrings } from '@/composables/useStrings.ts'

  export default {
    name: 'page-downloads',
    setup(){
      const { t } = useStrings()
      return {
        t,
      }
    },
    components: {
      About,
    },
  }
</script>

<style lang="scss">
  .page-about-app {
    max-width: $content-page-width;
  }
</style>
